/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportListUploadStatusesByPlatformQueryResponse, SocialExportListUploadStatusesByPlatformPathParams, SocialExportListUploadStatusesByPlatform400, SocialExportListUploadStatusesByPlatform401, SocialExportListUploadStatusesByPlatform403 } from "../models/SocialExportListUploadStatusesByPlatform";

export function getSocialExportListUploadStatusesByPlatformUrl(platform: SocialExportListUploadStatusesByPlatformPathParams["platform"]) {
  const res = { method: 'GET', url: `/social-export/v1/upload/status/all/${platform}` as const }
  return res
}

/**
 * @description Returns all uploads for the authenticated client on the given platform.
 * @summary List upload statuses for a platform
 * {@link /social-export/v1/upload/status/all/:platform}
 */
export async function socialExportListUploadStatusesByPlatform(platform: SocialExportListUploadStatusesByPlatformPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportListUploadStatusesByPlatformQueryResponse, ResponseErrorConfig<SocialExportListUploadStatusesByPlatform400 | SocialExportListUploadStatusesByPlatform401 | SocialExportListUploadStatusesByPlatform403>, unknown>({ method : "GET", url : getSocialExportListUploadStatusesByPlatformUrl(platform).url.toString(), ... requestConfig })
  return res.data
}